/* BTU Sizer — Shop by Size. Data-driven from DOM (.bz-seg blocks).
   Multi-instance safe: inits every [data-bz-sizer] once. No deps.
   21.10.2026 — rule v1 (snippets/ms4l-sizing via <script id="ms4l-sizing">, same as the calculator): load = area x 22 x
   (1 + ceiling + sun) + 4,000 BTU for a kitchen, corrections ADD up (were multiplied; kitchen was +150 ft2); the tier is
   the smallest one whose "up to" x 22 covers the load; above the largest tier — "more than one system". */
(function () {
  function initSizer(root) {
    if (root.dataset.bzReady === "1") return;
    root.dataset.bzReady = "1";

    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var fmt = function (n) { return Number(n).toLocaleString("en-US"); };

    var range = $(".bz-range");
    var segs = $$(".bz-seg");
    if (!range || !segs.length) return;

    // Build ordered tier list from the scale segments (single source of truth).
    var tiers = segs.map(function (el) {
      return {
        el: el,
        btu: parseInt(String(el.dataset.btu).replace(/,/g, ""), 10) || 0,   /* 21.10.2026: "18,000" -> 18000 (было 18 — гид писал «18 BTU») */
        cov: parseInt(el.dataset.cov, 10) || 0,
        label: el.dataset.label || "",
        href: el.dataset.href || "#",
        ton: el.dataset.ton || ""
      };
    }).sort(function (a, b) { return a.cov - b.cov; });

    var PRESET_NAME = { 200: "bedroom", 400: "office", 600: "living room", 1200: "open space", 2400: "commercial space" };
    function nameFor(sqft) {
      var best = "space", d = 1e9;
      for (var k in PRESET_NAME) { var diff = Math.abs(k - sqft); if (diff < d) { d = diff; best = PRESET_NAME[k]; } }
      return best;
    }
    var SZ = {};
    try { SZ = JSON.parse(document.getElementById("ms4l-sizing").textContent) || {}; } catch (e) {}
    var B = SZ.bpsf || 22;
    function pickTier(load) {
      for (var i = 0; i < tiers.length; i++) { if (tiers[i].cov * B >= load) return tiers[i]; }
      return null;
    }

    function compute() {
      var sqft = parseInt(range.value, 10) || 0;
      var add = 0;
      var ceil = $(".bz-ceil"), sun = $(".bz-sun"), kit = $(".bz-kit");
      if (ceil && ceil.checked) add += 2 * (SZ.ceil || 0.06);   /* "high ceilings" = 10 ft: +6% per foot over 8 */
      if (sun && sun.checked) add += (SZ.sun || 0.1);
      var load = Math.round(sqft * B * (1 + add) + (kit && kit.checked ? (SZ.kit || 4000) : 0));
      var tier = pickTier(load), over = !tier;
      if (over) tier = tiers[tiers.length - 1];

      var sq = $(".bz-sqft-val"); if (sq) sq.textContent = fmt(sqft);
      var btu = $(".bz-btu-val"); if (btu) btu.textContent = fmt(tier.btu);
      var ton = $(".bz-ton-val"); if (ton) ton.textContent = tier.ton + " ton";
      var cov = $(".bz-cover-val"); if (cov) cov.textContent = fmt(tier.cov);
      var sub = $(".bz-sub"); if (sub) sub.textContent = over
        ? "~" + fmt(sqft) + " sq ft needs more than one system \u2014 call (855) 775-4822"
        : "Best fit for a ~" + fmt(sqft) + " sq ft " + nameFor(sqft);
      var cta = $(".bz-cta"); if (cta) cta.setAttribute("href", tier.href);
      var ctaSize = $(".bz-cta-size"); if (ctaSize) ctaSize.textContent = tier.label;

      segs.forEach(function (s) { s.classList.toggle("is-on", s === tier.el); });
      $$(".bz-chip").forEach(function (c) { c.classList.toggle("is-on", parseInt(c.dataset.sqft, 10) === sqft); });
      $$(".bz-desc__item").forEach(function (it) { it.hidden = (it.getAttribute("data-desc") !== tier.label); });
      centerSeg(tier.el);
    }

    var scale = $(".bz-scale");
    function centerSeg(seg) {
      if (!scale || !seg) return;
      var sRect = scale.getBoundingClientRect(), gRect = seg.getBoundingClientRect();
      var delta = (gRect.left - sRect.left) - (scale.clientWidth - seg.offsetWidth) / 2;
      if (Math.abs(delta) < 2) return;
      // instant during drag to avoid jank; the CSS scroll-behavior handles clicks
      scale.scrollLeft += delta;
    }

    range.addEventListener("input", compute);
    $$(".bz-chip").forEach(function (c) {
      c.addEventListener("click", function () { range.value = c.dataset.sqft; compute(); });
    });
    segs.forEach(function (s) {
      s.addEventListener("click", function () { range.value = s.dataset.cov; compute(); });
    });
    ["bz-ceil", "bz-sun", "bz-kit"].forEach(function (cls) {
      var el = $("." + cls); if (el) el.addEventListener("change", compute);
    });

    compute();
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll("[data-bz-sizer]");
    Array.prototype.forEach.call(nodes, initSizer);
  }

  if (document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", function () { initAll(); });

  // Shopify theme editor: re-init when the section is loaded/reordered.
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();
